import { useState, useEffect, useCallback, useMemo } from "react";
import { Container, Col } from "react-bootstrap";
import 'animate.css';
import { useMediaQuery } from "react-responsive";
import banner from "../assets/img/landing port no-bg.png";
import { renderTextBlock } from "./RenderTextBlocks";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const period = 5000;

  const isMobile = useMediaQuery({ maxWidth: 767 });

  const toRotate = useMemo(() => [" Programmer", " Developer", " Enthusiast", " Engineer"], []);

  const tick = useCallback(() => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 1.2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setDelta(period);
      setTimeout(() => setDelta(100), period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setDelta(100);
    }
  }, [isDeleting, loopNum, text, toRotate, period]);

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text, delta, tick]);

  const scrollToProjects = () => {
    const projectsSection = document.getElementById("projects");
    if (projectsSection) {
      projectsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="banner" id="home">
      <Container className="width-base banner-container">
        <div className="banner-text banner-row align-items-center justify-content-center text-center">
          <Col size={12} md={7} className="banner-col banner-col-left">
            <h1 className={isMobile ? "h1-mobile" : ""}>Projects<span style={{ color: "var(--color-accent)", transition: "color 0.2s ease-in-out" }}>.</span></h1>
            <h5 className={isMobile ? "h4-mobile" : ""}>
              {renderTextBlock(`Check out some of my game development work.`)}
            </h5>
            <p>
              {renderTextBlock(`Here you can find all my projects — filter by professional, personal, or side work to explore specific types.`)}
            </p>
          </Col>

          <Col size={12} md={5} className="banner-col banner-col-right">
            <img src={banner} alt="banner" className="banner-img" />
          </Col>
        </div>
      </Container>
      <button onClick={scrollToProjects} className="scroll-btn">
        {/* Add your button content here, e.g., an icon */}
      </button>
    </section>
  );
};
